import React, { useEffect, useRef } from 'react'

declare global {
    interface Window {
        DG: any
    }
}

const Map2Gis: React.FC = () => {
    const mapRef = useRef<any>(null)

    useEffect(() => {
        if (!window.DG || mapRef.current) return

        window.DG.then(() => {
            if (mapRef.current) return // если уже есть карта — выходим

            const map = window.DG.map('map-container', {
                center: [62.03272359875734, 129.7503733652411],
                zoom: 16,
            })

            window.DG.marker([62.032717, 129.750516])
                .addTo(map)
                .bindTooltip('Местоположение', {
                    permanent: true,
                    className: 'permanent-tooltip',
                    opacity: 1,
                })

            mapRef.current = map
        })
    }, [])

    return (
        <div
            id="map-container"
            style={{
                width: '100%',
                height: '400px',
                border: '1px solid #ccc',
            }}
        />
    )
}

export default Map2Gis
